export enum ErrorStatusCode {
    addClientError = 1,
    editClientError = 2,
    getClientsError = 3,
    getClientError = 4,
    getActionsReportError = 5,
    deleteClientError = 6,
    duplicateHostError = 7,
    invalidHostError = 8,
    getHistoryError = 9,
    getHostsError = 100,
    clientIdError = 101,
    badRequestError = 400,
    notFoundError = 404,
    internalServerError = 500,
}
